import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import PanelRightIcon from '@atlaskit/icon/core/panel-right';

import {
	PARENT_PRODUCTS,
	useConfluencePagePreviewPanel,
} from '@atlassian/confluence-page-preview-panel';
import { useIsPreviewPanelOpen } from '@atlassian/preview-panels-api';

import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';

export const PreviewPanelTestButton = () => {
	const previewPanelUrl = StatsigConfigurations.getString(
		'confluence_page_preview_panel_testing',
		'',
	);
	const title = `${previewPanelUrl.split('/').pop()}`;

	const { openConfluencePagePreviewPanel, closeConfluencePagePreviewPanel } =
		useConfluencePagePreviewPanel(PARENT_PRODUCTS.CONFLUENCE);
	const isOpen = useIsPreviewPanelOpen();

	if (!previewPanelUrl) {
		return null;
	}

	return (
		<IconButton
			icon={PanelRightIcon}
			label="Preview Panel Test"
			onClick={() =>
				isOpen
					? closeConfluencePagePreviewPanel()
					: openConfluencePagePreviewPanel(title, previewPanelUrl)
			}
		/>
	);
};
